import blocker from '@motionelements/core/src/store/modules/blocker.js';

export default {
  namespaced: true,
  state: () => blocker.state,
  getters: blocker.getters,
  actions: blocker.actions,
  mutations: blocker.mutations,
};
